/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportLodgingChainsV2MutationRequest,
  ExportLodgingChainsV2MutationResponse,
  ExportLodgingChainsV2400,
  ExportLodgingChainsV2500,
} from '../types/ExportLodgingChainsV2'

function getExportLodgingChainsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/places/lodging/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async lodging chains export.
 * @summary Start an async lodging chains export
 * {@link /api/v1/places/lodging/export/v2/}
 */
export async function exportLodgingChainsV2(
  data: ExportLodgingChainsV2MutationRequest,
  config: Partial<RequestConfig<ExportLodgingChainsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportLodgingChainsV2MutationResponse,
    ResponseErrorConfig<ExportLodgingChainsV2400 | ExportLodgingChainsV2500>,
    ExportLodgingChainsV2MutationRequest
  >({
    method: 'POST',
    url: getExportLodgingChainsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
